import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'MetaListPipe' })
export class MetaListPipe implements PipeTransform {
  transform(cardTypes: any, joiner: string): string {
    if (!cardTypes || !cardTypes.length) {
      return null;
    }
  
    // Split only by commas, not by spaces.
    let content = cardTypes.flatMap((item) => item.split(/,+/)); // Split only by commas
    content = content.slice(0, 3); // Max 3 types to be shown
    let formattedCardTypes = content
      .filter(Boolean)                // Remove any empty strings
      .map((word) => word.trim())     // Trim spaces from each item
      .join(' ' + joiner + ' ');      // Join with the specified joiner, surrounded by spaces
  
    return formattedCardTypes;
  }
}
